import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { ContentUpgrades } from "@swizec/gatsby-theme-course-platform";
export const _frontmatter = {
  "title": "Flow good for programming, not engineering",
  "description": "Friend, how good are you at your best? ... Nobody cares. How good are you at your average? What about your worst?",
  "published": "2021-04-24T00:00:00.000Z",
  "categories": "Opinions, Mindset, Flow",
  "content_upgrade": "SeniorMindset",
  "hero": "./img/screenshot-1619282197500.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Friend, how good are you at your best?`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media4.giphy.com/media/WrJ8x0niiblWEoo7hE/giphy-loop.mp4?cid=7cf28b0fwy24md6umu62nkx7i8wmkgu84kpabms2i43j1xw3&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`Nobody cares. How good are you at your average? What about your worst?`}</p>
    <p>{`Everyone's great at their best. When the stars align, the energy is just right, the temperature is perfect, the code hits that sweet spot between easy and challenging, you had the perfect burrito, and your beverage tastes amazing and endless.`}</p>
    <p>{`Your fingers glide across the keyboard, your brilliance is endless, an aria sounds from the heavens when you run your code.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media0.giphy.com/media/glvyCVWYJ21fq/giphy-loop.mp4?cid=7cf28b0fbdgmeue7k6qrpdxruj5g7iektdnjz2t16mz1cxpu&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <ContentUpgrades.SeniorMindset />
    <h2 {...{
      "id": "reality-doesnt-play-fair"
    }}>{`Reality doesn't play fair`}</h2>
    <p>{`\\`}{`<`}{`record scratch>`}</p>
    <p>{`That's not how reality works you doodoo!`}</p>
    <p>{`Reality looks like a scene from a bad sitcom.`}</p>
    <p>{`You roll into work 10 minutes late because your car broke down, the coffee machine is broken, you spill water on your keyboard, slack pings you every 10 seconds with an oh so very important message, JIRA screams at you about bugs, production is down, your new team member can't get their local environment to run, and the PM is like `}<em parentName="p">{`"Yo, where's that feature you promised last week?"`}</em></p>
    <p>{`Oh and your computer started an update in the middle of a Zoom call (you were presenting), kicked you out, and now Chrome won't start.`}</p>
    <p>{`How good's your code now my friend?`}</p>
    <p><em parentName="p">{`That`}</em>{`'s where you must focus your energy. How good is your performance on a terrible annoying hell of a day?`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`How good are you at your worst? Work on that.`}<br parentName="p"></br><br parentName="p"></br>{`Everyone’s great at their best.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1381302636373102594"
      }}>{`April 11, 2021`}</a></blockquote>
    <p>{`We idolize folks like Jimmy Hendrix, Ayrton Senna, Michael Jordan, and Queen not because they had a few fantastic days here and there. We idolize them `}<em parentName="p">{`because they were great every time`}</em>{`.`}</p>
    <p>{`It's your typical performance that defines you. Consistency. `}<a parentName="p" {...{
        "href": "https://a16z.com/book/whatyoudo/"
      }}>{`What You Do is Who You Are`}</a>{` as Ben Horowitz would say.`}</p>
    <h2 {...{
      "id": "what-does-that-have-to-do-with-flow"
    }}>{`What does that have to do with flow??`}</h2>
    <p>{`Flow is when you're at your best.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "850px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/19cba53fee515ac01a06eb0e7c9aedbb/ae694/wmDxWjpnghd982j.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.08520179372197%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'188\\'%20viewBox=\\'0%200%20400%20188\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2094v94h401V0H0v94m0%200v94l200-1h199V1H0v93m2-72c0%2023-1%2021%2010%2021%208%200%209%200%207%208v11c3%206%204%2021%203%2044%200%201-1%202-6%202l-10%201H2v14l2%2017c1%204%201%205-1%2011l-1%2021v14h12v-4l1-5%201-3%201-4c0-3%200-3-2-3h-2c0-2%204-3%205-1%200%202%207-4%208-7%200-2%202-3%204-4%203-1%203-2%203-7v-2l-1%201h-4v-3c3-4%204-4%207-1%203%202%206%203%206%201l-1-2c-3-1-8-11-8-13l2-4c5-2%208%201%2015%2010%203%204%205%205%205%203l1-2%201-2-1-1c-2%201-8-4-8-5h3l4-1%2012-1%2011-2%203%203c3%203%204%202%203-2v-3c1-2-2-5-5-5s-2%203%201%204c4%201%200%202-8%202h-6l2-2c2-3%202-5%200-3h-4l-3-2c-2%200-4-3-3-4%201-3%202-27%200-30l-6-3h-2v-1c2%200%201-2-4-5l-8-5-3-2c-2%200-2-2-1-4l1-7%202-7%201-4v-2l2-2%202-2%202-1%202-1%201%201h15c2%200%202%200-2-3-5-2-5-2-2-2l3-1h-2l-3-1-2-2-6-2-5-2-2-2c0-2%200-2%205-1%207%201%2011%201%2011-1l-3-2-3-1h2l4-1c4%201%204%200%202-2s-3-2-7-1c-9%200-9%201-16%206-8%206-9%206-6%201%204-8%2013-15%2024-17%202-1-5-1-24-1H2v20M80%204l4%202c11%202%2025%2010%2020%2012-2%201-2%204-1%206%201%201%202%202%201%204l2%204c3%201%204%205%202%204s-2-2%200%2017l2%2018c0%205%201%205%202%202l2-3%201-2c0-4%201-6%202-5l1-1%201-2%201%205c0%205%201%205%203%201%203-9-2-32-9-40-5-6-1-5%204%201%205%205%206%208%208%2017%201%206%201%207%208%208l6%201v32l-1%2031-7-4-3-5c-2-4-7-8-10-8s-2%202%200%203c3%201%203%203%200%209l-3%206-7%2014v-2c1-4-1-3-7%204l-8%209-2%204-6%207a62%2062%200%2000-12%2018c-3%203-4%207-4%2011v4h26l25-1%202-3v-6l2-3c0-2%207-12%2010-14l2-4c0-3%201-5%202-5l1%2016v15l-3%203-2%202h263V2H238C92%202%2078%202%2080%204m6%2069h-6c-3%200-4%200-5%202-3%203-2%204%208%204h13c3-3%202-4-3-5-5-2-5-2-7-1m-54%204l-3%204c-2%201-1%209%202%2016%201%205%200%2019-2%2022-2%201%200%205%201%203h5c6%201%207%200%206-2l1-3h1l1%202c1%200%203-5%203-8l2-7%202-6%201-6%202-5-3-3c-2-3-3-3-4-2-2%202-6%201-7-1s-4%200-3%203c0%201%200%202-2%202-4-1-4-4%200-8%202-2%202-2%207-1h6l-10-3c-5%200-5%200-6%203m45%205h-4c-4-2-5%202-1%204l2%203c0%202%203%203%204%202v-3c-2-3%201-5%203-2%202%202%203%203%205%200%202-1%202-1%205%201%204%203%205%202%202-2-4-3-12-5-16-3M2%20102c0%206%200%206%202%206l9-2c7-1%209-2%207-5l-8-3c-10-3-10-3-10%204\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/19cba53fee515ac01a06eb0e7c9aedbb/ca0a1/wmDxWjpnghd982j.webp 223w", "/static/19cba53fee515ac01a06eb0e7c9aedbb/75680/wmDxWjpnghd982j.webp 445w", "/static/19cba53fee515ac01a06eb0e7c9aedbb/10237/wmDxWjpnghd982j.webp 850w"],
              "sizes": "(max-width: 850px) 100vw, 850px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/19cba53fee515ac01a06eb0e7c9aedbb/e92b6/wmDxWjpnghd982j.png 223w", "/static/19cba53fee515ac01a06eb0e7c9aedbb/e66bf/wmDxWjpnghd982j.png 445w", "/static/19cba53fee515ac01a06eb0e7c9aedbb/ae694/wmDxWjpnghd982j.png 850w"],
              "sizes": "(max-width: 850px) 100vw, 850px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/19cba53fee515ac01a06eb0e7c9aedbb/ae694/wmDxWjpnghd982j.png",
              "alt": "wmDxWjpnghd982j",
              "title": "wmDxWjpnghd982j",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Mihaly Csikszentmihalyi invented/discovered/defined flow. I wrote about it lots in `}<a parentName="p" {...{
        "href": "http://nightowlsbook.com/"
      }}>{`Why Programmers Work at Night`}</a>{` back when I thought flow was the only way to code.`}</p>
    <p>{`But flow is hard to get.`}</p>
    <p>{`Most days work is ... work. You put one foot in front of the other until you get where you're going.`}</p>
    <p>{`That's because programming and engineering are two different things.`}</p>
    <p><strong parentName="p">{`Programming is fun`}</strong>{`, almost art. Solving hard problems in beautiful ways. Flow is perfect.`}</p>
    <p><strong parentName="p">{`Engineering is work`}</strong>{`. Solving hard problems in obvious stupid ways. Flow is unnecessary.`}</p>
    <p>{`The emphasis is on how will a bunch of distracted people with no skin in the game and zero care for your code maintain this when you're not there to be brilliant?`}</p>
    <p>{`And remember 👉 they're upset because they were late for work, spilled their coffee, and got pulled in a million directions as soon as they sat down.`}</p>
    <p>{`If you wrote it in flow, at your most brilliant, they might not even understand your code! `}<em parentName="p">{`YOU`}</em>{` won't understand it when you're distracted and upset.`}</p>
    <p>{`Remember Kernighan's Law: debugging is hard.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Cue the classic Kernighan quote ( `}<a parentName="p" {...{
          "href": "https://t.co/rQ7dKtdLf0"
        }}>{`https://t.co/rQ7dKtdLf0`}</a>{` ):`}<br parentName="p"></br><br parentName="p"></br>{`"Debugging is twice as hard as writing, so if you're too clever when you write it you're not qualified to debug it"`}</p>{`— Mark Erikson (@acemarke) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/acemarke/status/1384959487388356612"
      }}>{`April 21, 2021`}</a></blockquote>
    <h2 {...{
      "id": "what-can-you-do-about-it"
    }}>{`What can you do about it?`}</h2>
    <p>{`Not much. Keep going.`}</p>
    <p>{`When shit's going down, when everything's crap, the best way forward is through.`}</p>
    <p>{`And `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/when-you-code-write-down-everything"
      }}>{`when you code, write down everything`}</a>{`. It helps you recover from interruptions.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: remember to read the docs`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`developers who work hard and avoid docs `}<a parentName="p" {...{
          "href": "https://t.co/YoNWNlu3Zk"
        }}>{`pic.twitter.com/YoNWNlu3Zk`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1381753711836286988"
      }}>{`April 12, 2021`}</a></blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      